import { $api } from "../AxiosInstance";

export class LanguageService {

  /**
   * Get translation by ID
   * @param {Number} id
   */

  static async languageGet(id) {
    return await $api.get("/api/admin/language", {params: {id}});
  }

  /**
   * Update language
   * @param {Object} languageData
   * @param {String} languageData.id
   * @param {String} languageData.name
   * @param {String} languageData.code
   * @param {String} [languageData.languageNameInternational]
   * @param {String} [languageData.languageNameOriginal]
   * @param {String} languageData.alpha2
   * @param {String} languageData.originalName
   * @param {String} languageData.internationalName
   * @param {String} languageData.rfc4646
   * @param {Boolean} languageData.isDefault
   * @param {Boolean} languageData.isActive
   * @param {"LEFT"|"RIGHT"} languageData.pageTextDirection
   */
  static async languageUpdate(languageData) {
    return await $api.put("/api/admin/language", languageData);
  }

  /**
   * Create language
   * @param {Object} languageData
   * @param {String} languageData.name
   * @param {String} languageData.code
   * @param {String} [languageData.languageNameInternational]
   * @param {String} [languageData.languageNameOriginal]
   * @param {String} languageData.alpha2
   * @param {String} languageData.originalName
   * @param {String} languageData.internationalName
   * @param {String} languageData.rfc4646
   * @param {Boolean} languageData.isDefault
   * @param {Boolean} languageData.isActive
   * @param {"LEFT"|"RIGHT"} languageData.pageTextDirection
   */
  static async languageCreate(languageData) {
    return await $api.post("/api/admin/language", languageData);
  }

  static async setDefaultLanguage(id, lang) {
    const updateLang = { ...lang, isDefault: true, id };
    return await $api.put("/api/admin/language", updateLang);
  }

  static async setActiveToggleLanguage(id, lang, isActive) {
    const updateLang = { ...lang, isActive , id };
    return await $api.put("/api/admin/language", updateLang);
  }

  /**
   * Get all languages
   */
  static async getAllLanguages() {
    return await $api.get("/api/admin/language/all");
  }

  static async languageDelete(id) {
    return await $api.delete("/api/admin/language", {params: {id}});
  }
}
